import { render, staticRenderFns } from "./receiveProduct.vue?vue&type=template&id=477b41d0&scoped=true&"
import script from "./receiveProduct.vue?vue&type=script&lang=js&"
export * from "./receiveProduct.vue?vue&type=script&lang=js&"
import style0 from "./receiveProduct.vue?vue&type=style&index=0&id=477b41d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477b41d0",
  null
  
)

export default component.exports